module.exports = __webpack_public_path__ + "static/media/license_am.87b95985.png";